/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { FirstNameCell } from "./FirstNameCell";
import { emailCell, RolesCell } from "./RolesCell";
import { ActionCell } from "./ActionCell";
import { OrganisationCell } from "./helper";
import { localeKeyMap } from "../../../localization/keys";
import { ControlSuccess, StatusBadge } from "@forge/common";
import { STATUS_COLORS } from "../../../utils/constants";

// Reusable status cell renderer
const renderStatusCell = (cellValues: any) => {
  const status = cellValues?.row?.status;

  if (!status) return null;

  const displayStatus = status.charAt(0) + status.slice(1).toLowerCase();
  const statusColor =
    STATUS_COLORS[status as keyof typeof STATUS_COLORS] ||
    STATUS_COLORS.DEFAULT;

  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <div style={{ flexShrink: 0 }}>
        <StatusBadge color={statusColor} />
      </div>
      <span style={{ whiteSpace: "nowrap" }}>{displayStatus}</span>
    </div>
  );
};

export const gridColumns = (props: any) => {
  const { t = (key: string) => key } = props;
  const obj: any = {
    tenantUserPage: [
      {
        field: "firstName",
        headerName: <p className="menu-title-2">{t(localeKeyMap.name)}</p>,
        flex: 1,
        renderCell: (cellValues: any) => FirstNameCell(cellValues, props),
        sortable: true,
      },
      {
        field: "emailId",
        headerName: <p className="menu-title-2">{t(localeKeyMap.emailId)}</p>,
        flex: 2,
        renderCell: (cellValues: any) => emailCell(cellValues),
      },
      {
        field: "roles",
        headerName: <p className="menu-title-2">{t(localeKeyMap.roles)}</p>,
        valueGetter: (cellValues: any) =>
          cellValues.row.roles.map((x: { name: any }) => x.name).join(", "),
        flex: 1,
        sortable: true,
        renderCell: RolesCell,
      },
      {
        field: "organization",
        headerName: (
          <p className="menu-title-2">{t(localeKeyMap.organization)}</p>
        ),
        sortable: false,
        flex: 1.5,
        renderCell: OrganisationCell,
      },
      {
        field: "sso_enabled",
        headerName: <p className="menu-title-2">{t(localeKeyMap.sso)}</p>,
        flex: 0.5,
        sortable: false,
        renderCell: (cellValues: any) => (
          <>{cellValues.row.sso_enabled ? <ControlSuccess /> : null}</>
        ),
      },
      {
        field: "status",
        headerName: <p className="menu-title-2">{t(localeKeyMap.status)}</p>,
        flex: 0.75,
        sortable: true,
        renderCell: renderStatusCell,
      },
      {
        headerName: <p className="menu-title-2">{t(localeKeyMap.action)}</p>,
        flex: 1,
        sortable: false,
        headerAlign: "right",
        align: "right",
        renderCell: (cellValues: any) => (
          <ActionCell cellValues={{ ...cellValues }} props={{ ...props }} />
        ),
      },
    ],

    // This contains columns for Org user list page
    organizationUserList: [
      {
        field: "name",
        headerName: <p className="menu-title-2">{t(localeKeyMap.name)}</p>,
        flex: 1,
        // renderCell: NameCell,
        renderCell: (cellValues: any) => FirstNameCell(cellValues, props),
        sortable: true,
        valueGetter: (cellValues: any) =>
          cellValues?.row?.firstName + " " + cellValues?.row?.lastName,
      },
      {
        field: "emailId",
        headerName: <p className="menu-title-2">{t(localeKeyMap.emailId)}</p>,
        flex: 1,
        renderCell: (cellValues: any) => emailCell(cellValues),
      },
      {
        field: "roles",
        headerName: <p className="menu-title-2">{t(localeKeyMap.roles)}</p>,
        flex: 1,
        renderCell: RolesCell,
        sortable: true,
        valueGetter: (cellValues: any) =>
          cellValues?.row?.roles?.map((x: { name: any }) => x.name).join(", "),
      },
      {
        field: "organization",
        headerName: (
          <p className="menu-title-2">{t(localeKeyMap.organization)}</p>
        ),
        sortable: false,
        flex: 1.5,
        renderCell: OrganisationCell,
      },
      {
        field: "sso_enabled",
        headerName: <p className="menu-title-2">{t(localeKeyMap.sso)}</p>,
        flex: 0.5,
        sortable: false,
        renderCell: (cellValues: any) => (
          <>{cellValues.row.sso_enabled ? <ControlSuccess /> : null}</>
        ),
      },
      {
        field: "status",
        headerName: <p className="menu-title-2">{t(localeKeyMap.status)}</p>,
        flex: 0.75,
        sortable: true,
        renderCell: renderStatusCell,
      }
    ],
  };
  return obj[props.component];
};

export default gridColumns;
